import { theme } from '@chakra-ui/react';

export const heading = {
	baseStyle: {
		fontWeight: '600',
		color: theme.colors.white,
	},
	baseProps: {
		size: 'md',
	},
};
